import type { CSSProperties } from 'react';

export const backdropStyle: CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,0.55)',
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'center',
  zIndex: 40,
};

export const sheetStyle: CSSProperties = {
  width: '100%',
  maxHeight: '85vh',
  background: 'var(--color-surface)',
  borderTop: '1px solid var(--color-border)',
  borderTopLeftRadius: 'var(--radius-xl)',
  borderTopRightRadius: 'var(--radius-xl)',
  padding: '12px 16px 24px',
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  animation: 'gb-slide-up 0.2s ease-out',
};

export const grabberStyle: CSSProperties = {
  width: 36,
  height: 4,
  borderRadius: 2,
  background: 'var(--color-border)',
  margin: '0 auto 8px',
};
